var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOptionsEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_create",
    "data-name": " create",
    transform: "translate(-576 -1482)",
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 18,
    height: 18,
    transform: "translate(576 1482)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.36,12H.334A.33.33,0,0,1,0,11.666V9.64A.331.331,0,0,1,.1,9.4L7.372,2.128l2.5,2.5L2.594,11.9A.313.313,0,0,1,2.36,12Zm8.225-8.085h0l-2.5-2.5L9.305.2a.664.664,0,0,1,.94,0l1.56,1.56a.664.664,0,0,1,0,.939l-1.219,1.22Z",
    transform: "translate(579 1485)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOptionsEditIcon);
export default __webpack_public_path__ + "static/media/menu-options-edit-icon.5dcc9ec6ee283ff46d2fa179f97344fe.svg";
export { ForwardRef as ReactComponent };